<script>

  export let value
</script>

<input
  type="number"
  bind:value={value}
/>

<style>
  input {
    border: solid 2px #cccccc;
    border-radius: 6px;
    padding: 0.3em 0.8em;
    font-size: 1em;
    font-family: sans-serif;
    max-width: 150px;
    outline: none;
  }
  input:focus {
    border-color: #00468f;
  }
</style>
